import { render, staticRenderFns } from "./EventsBookingDetails.vue?vue&type=template&id=4063c99b&scoped=true&"
import script from "./EventsBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./EventsBookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063c99b",
  null
  
)

export default component.exports